export default __webpack_public_path__ + "static/media/PT-Root-UI_Bold.b951c0ef.woff2";